var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8125 0.703125C8.16134 0.703125 7.56434 0.909469 7.03812 1.31644C6.53362 1.7066 6.19774 2.20355 6 2.56491C5.80226 2.20352 5.46638 1.7066 4.96188 1.31644C4.43566 0.909469 3.83866 0.703125 3.1875 0.703125C1.37034 0.703125 0 2.18946 0 4.16048C0 6.28988 1.7096 7.74677 4.29771 9.95231C4.73721 10.3269 5.23538 10.7514 5.75316 11.2042C5.82141 11.264 5.90906 11.2969 6 11.2969C6.09094 11.2969 6.17859 11.264 6.24684 11.2042C6.76467 10.7514 7.26281 10.3268 7.70257 9.95208C10.2904 7.74677 12 6.28988 12 4.16048C12 2.18946 10.6297 0.703125 8.8125 0.703125Z",
    fill: "#7A858C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.5a2a4280.svg";
export { ForwardRef as ReactComponent };